
import { rootApi } from "../../api/rootApi";

export const appGalleryApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addAppGallery: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/appGallery/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    getAppGallery: builder.mutation({
      query: (params) => {
        let url = `/tenant/appGallery`;
        if (params?.language) {
          url += `?language=${encodeURIComponent(params.language)}`;
        }
        return {
          method: "GET",
          url,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

      deleteAppGallery: builder.mutation({
        query: (params) => {
          return {
            method: "DELETE",
            url: `/tenant/appGallery/${params.id}`,
            headers: {
              Authorization: "Bearer " + params.token,
              slug: params.tenant_id,
            },
          };
        },
      }),
  }),
});

export const { useAddAppGalleryMutation ,useGetAppGalleryMutation , useDeleteAppGalleryMutation} = appGalleryApi;
